import { FC, useMemo } from 'react';

import { useFormikContext } from 'formik';
import { Button } from 'ui/components/common';
import { Input } from 'ui/components/form';
import { SIZE } from 'utils/constants';

import { FORGOT_PASSWORD_FORM } from './schema';

interface PROPS {
  disabled: boolean;
}

const ForgotPasswordForm: FC<PROPS> = ({ disabled }) => {
  const {
    values,
    touched,
    errors,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
  } = useFormikContext<FORGOT_PASSWORD_FORM>();

  const passed = useMemo(() => {
    if (isSubmitting || Object.entries(errors).length) return true;

    if (!values.emailAddress) {
      return true;
    }

    return false;
  }, [values, errors, isSubmitting]);

  return (
    <form onSubmit={handleSubmit}>
      <Input
        className="w-full mb-[12px]"
        type="text"
        name="emailAddress"
        size={SIZE.Large}
        textType={
          errors.emailAddress && touched.emailAddress ? 'danger' : 'default'
        }
        onChange={handleChange}
        onBlur={handleBlur}
        value={values.emailAddress}
        placeholder="Email Address"
        subText={
          errors.emailAddress && touched.emailAddress
            ? errors.emailAddress
            : undefined
        }
        disabled={isSubmitting}
      />
      <Button
        label="RESET YOUR PASSWORD"
        type="submit"
        disabled={passed || disabled}
        className="font-semibold mb-[15px] w-full"
        size="lg"
      />
    </form>
  );
};

export default ForgotPasswordForm;
